import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { notificationsApi } from '../api/notifications.api';
import { notificationsKeys } from '../api/notifications.keys';
import type { NotificationType } from '../types';

/** Unread counts for the two bells. Polled lightly; kept fresh by the socket. */
export function useUnreadCounts() {
    return useQuery({
        queryKey: notificationsKeys.unreadCount(),
        queryFn: notificationsApi.unreadCount,
        staleTime: 30_000,
    });
}

/** First page for one tab (the popover peek shows the top `limit`). */
export function useNotificationsList(type: NotificationType, enabled: boolean, limit = 5) {
    return useQuery({
        queryKey: notificationsKeys.list(type, limit),
        queryFn: () => notificationsApi.list({ type, limit }),
        enabled,
        staleTime: 15_000,
    });
}

export function useMarkNotificationRead() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id: string) => notificationsApi.markRead(id),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: notificationsKeys.all });
        },
    });
}

export function useMarkAllNotificationsRead() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (type?: NotificationType) => notificationsApi.markAllRead(type),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: notificationsKeys.all });
        },
    });
}
